module.exports = __webpack_public_path__ + "img/24_1909_atp.39007fb2.jpg";